import { Component, SimpleChanges, Input, HostBinding } from '@angular/core';
import { Router } from '@angular/router';

import { ComponentBase } from '@framework/base/component';
import { AuthService } from '@framework/services';
import { CampaignViewModel, CompanyViewModel } from '@modules/company/models/store-view-models';
import { lightenColor } from '@modules/shared/utils/color.util';
import { guestInterviewCreateCommands } from '@modules/company/utils/guest-story-submit-nav';

@Component({
  selector: 'co-pb-campaign-item',
  templateUrl: './campaign-item.component.html',
  styleUrls: ['./campaign-item.component.scss']
})
export class CampaignItemComponent extends ComponentBase {
  @Input() campaign: CampaignViewModel;
  @Input() company: CompanyViewModel;
  @Input() btnsubmit:any = '';
  @Input() txtsubmit: any = '';
  @Input() href: string;
  @HostBinding('class.campaign-item') campaignItemClass: boolean = true;
  @HostBinding('class.custom-div') customDivClass: boolean = true;

  /** View Storyboard = lighter shade of Submit Story (no separate theme setting). */
  get viewStoryboardBtn(): string {
    return this.btnsubmit ? lightenColor(this.btnsubmit, 0.35) : '';
  }

  constructor(private router: Router,    private authService: AuthService) {
    
    super();

 
  }

  // Life cycle hook
  protected onInit(): void {
    this.subscribe();
  }
  protected onDestroy(): void {
    this.unsubscribe();
  }
  protected onChanges(changes: SimpleChanges): void {

  }
  protected onDoCheck(): void {

  }
  protected onAfterContentInit(): void {

  }
  protected onAfterContentChecked(): void {

  }
  protected onAfterViewInit(): void {
  }
  protected onAfterViewChecked(): void {

  }

  // Private functions
  private subscribe() {

  }

  private unsubscribe() {

  }
  // Public functions

  public getSlugCompany(story) {
    return story.companyIdSlug;
  }

  navgateToInterviewStyle(camapaigns){
    const currentUser = this.authService.cognito.currentUser();
    if(!currentUser){
      this.router.navigate(guestInterviewCreateCommands(camapaigns.companySlug, camapaigns.slug));
    }
    else{
      this.navigateTOInternalINterview()
    }

  }

  public gotoDetail(camapaigns) {
    // Header / View Storyboard always open the campaign storyboard, never the builder.
    this.router.navigate([`/c/${camapaigns.companySlug}/campaigns/${camapaigns.slug}`]);
  }

  navigateToInternal(){
    // Submit Story path for authenticated users (builder/create).
    let url = '/company/campaigns/'+this.campaign?.slug+'/create';
    this.router.navigate([url])
  }

  navigateTOInternalINterview(){
  
    let url = '/interview/campaign/create/'+this.campaign.slug+'/'+this.campaign?.companySlug;
    this.router.navigate([url])
  }

  get storyPrompt() {
    if (this.campaign.storyPrompt) {
      // return btoa(unescape(encodeURIComponent(this.campaign.storyPrompt)));
    } else {
      return null;
    }
  }

  getauthor(data){
    if (data) {
      const oldBase = 'https://goodseeker-live-processed.s3.amazonaws.com/';
      const newBase = 'https://images.goodseeker.com/';
    
      if (data.includes(oldBase)) {
        //
        data = data.replace(oldBase, newBase);
        data =  data.replace(
          '?tr=n-stories_list',
          ''
        );
        return data
      }
 
      else{
        data =  data.replace(
          '?tr=n-stories_list',
          ''
        );
        return data
      }
    }
  }
}
